import type { NextPage } from "next";
import Head from "next/head";
import { useMemo } from "react";
import { PageProvider } from "@providers/page";

import Header from "../components/Header";
import PageLayout from "../components/PageLayout";
import Sidebar from "../components/Sidebar";

import Stake from "../container/pages/stake";
import { getStakeData } from "@services/gsheets";
import RightSidebar from "@components/RightSidebar";

import useLedgerCookies from "@hooks/useLedgerCookies";

export async function getStaticProps() {
  const [availableTags, tokenTagMapping] = await getStakeData();
  return { props: { availableTags, tokenTagMapping } };
}

interface PageProps extends Awaited<ReturnType<typeof getStaticProps>> {}

const Restake: NextPage<PageProps["props"]> = ({
  availableTags,
  tokenTagMapping,
}) => {
  const getHeader = useMemo(() => {
    return (
      <Head>
        {/* <title>Kelp</title>
        <meta name="description" content="Kelp" />
        <link rel="icon" href="/favicon.ico" /> */}
        <title>
          Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kelp
          Miles!
        </title>
        <meta
          name="description"
          content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kelp Miles."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta property="og:image" content="/restake_preview_image.png" />
        <meta
          property="og:title"
          content=" Liquid restaking | Restake ETH or LSTs, mint rsETH and earn Kelp Miles!"
        />
        <meta
          property="og:description"
          content="Unlock higher rewards and DeFi utility for restaked assets through liquid restaking with rsETH. Get dual rewards with EigenLayer Restaked Points and Kelp Miles."
        />
      </Head>
    );
  }, []);

  useLedgerCookies();

  return (
    <PageProvider value={{ pageData: { availableTags, tokenTagMapping } }}>
      {getHeader}

      <PageLayout
        Sidebar={
          <Sidebar display={{ base: "none", xl: "block" }} minH="100vh" />
        }
        MobileSideBar={<Sidebar />}
        Header={<Header />}
        RightSidebar={<RightSidebar />}
      >
        <Stake />
      </PageLayout>
    </PageProvider>
  );
};

export default Restake;
